import _ from 'lodash';
import React, {PropTypes} from 'react';
import {
  Avatar,
  FontIcon,
  IconButton
} from 'material-ui';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/user-task';
import MemberResourceRow from './MemberResourceRow';
import TaskRow from './TaskRow';
const defaultAvatar = require('../assets/images/default-avatar.png'); // Tell webpack to load image

class MemberRow extends React.Component {
  constructor(props) {
    super(props);
    this.handleHideUser = this.handleHideUser.bind(this);
  }

  handleHideUser(user) {
    this.props.actions.appendHiddenUidIfNeeded(user.uid);
  }

  render() {
    const {
      currentUser,
      user,
      firstDay,
      lastDay,
      onTaskTouchTap
    } = this.props;

    const totalHours = 8 * (lastDay.diff(firstDay, 'days') + 1);
    const usedHours = _.sum(_.values(user.dailyHours));
    let avatarUrl = defaultAvatar;
    if (user.avatarUrl) {
      avatarUrl = user.avatarUrl.replace(/s[0-9]+\-c/, 's40-c');
    }

    const handleTaskTouchTap = user.uid === currentUser.uid ? onTaskTouchTap : () => {};

    return <div className="row body-row">
      <div className="header-col">
        <Avatar src={avatarUrl} size={40}/>
        <IconButton
          tooltip="Hide this user"
          onClick={() => this.handleHideUser(user)}
          iconStyle={{color: 'rgb(200,200,200)'}}>
          <FontIcon className="material-icons">visibility_off</FontIcon>
        </IconButton>
        <div className="member-total-hours">
          {`${usedHours} / ${totalHours}`}
        </div>
        <div>{user.name}</div>
      </div>
      <div className="col">
        <MemberResourceRow
          user={user}
          firstDay={firstDay}
          lastDay={lastDay}
        />
        {user.tasks.map((t, i) => {
          return  <TaskRow
                    task={t}
                    firstDay={firstDay}
                    lastDay={lastDay}
                    onTaskTouchTap={handleTaskTouchTap}
                    key={i}
                  />
        })}
      </div>
    </div>
  }
}

MemberRow.propTypes = {
  actions: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  firstDay: PropTypes.object.isRequired,
  lastDay: PropTypes.object.isRequired,
  onTaskTouchTap: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemberRow);



/** WEBPACK FOOTER **
 ** ./src/components/MemberRow.js
 **/